import type { IFetchService, PostConfigObject } from "app/services/fetchService";

import type {
    LeadDomainsSearchResultsDto,
    LeadDomainsSearchResultsParams,
    LeadDetailedResultsRequestDto,
    LeadsDetailedResultsResponseDto,
} from "../../types/dto";

import { BASE_ENDPOINT_PATH } from "./const";

/**
 * Service for all "companies"-based endpoints
 */
export const createCompaniesApiService = (fetchService: IFetchService) => {
    const baseCompaniesPath = `${BASE_ENDPOINT_PATH}/companies`;

    return {
        fetchDetailedResults(
            dto: LeadDetailedResultsRequestDto,
            config?: PostConfigObject,
        ): Promise<LeadsDetailedResultsResponseDto> {
            return fetchService.post<LeadsDetailedResultsResponseDto>(`${baseCompaniesPath}/details`, dto, config);
        },

        fetchCompanyDomainsSearchResults(
            params: LeadDomainsSearchResultsParams,
            config?: PostConfigObject,
        ): Promise<LeadDomainsSearchResultsDto> {
            return fetchService.post(`${baseCompaniesPath}/${params.domain}/domains`, params.dto, config);
        },
    };
};
